import { cva } from "class-variance-authority"

// SCSS-based alert variants using WeLoop design system classes
export const alertVariants = cva(
  "wl-alert", // Base WeLoop alert class
  {
    variants: {
      variant: {
        default: "wl-alert-default",
        destructive: "wl-alert-destructive",
        warning: "wl-alert-warning",
        success: "wl-alert-success",
        info: "wl-alert-info",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
) 